import { Component, ViewChild } from '@angular/core';
import { ActiveModal } from '@healthcatalyst/cashmere';
import { TenantSwitcherComponent } from '../tenant-switcher/tenant-switcher.component';

@Component({
    templateUrl: './tenant-switcher-splash.component.html',
    styleUrls: ['./tenant-switcher-splash.component.scss'],
    standalone: false
})
export class TenantSwitcherSplashComponent {
    @ViewChild(TenantSwitcherComponent) tenantSwitcher: TenantSwitcherComponent;
    constructor(private activeModal: ActiveModal) {}

    onTenantSelected(): void {
        this.activeModal.close(true);
    }
}
